import { useQuery } from 'react-query';
import { getPinnedActivities } from '../redux/services/pinnedAcitvities';
import HookTypes from '../redux/types/hooks';
import { PinnedActivityResponse } from '../types/activity';

const useHook = () => {
  return useQuery<PinnedActivityResponse>({
    queryKey: [HookTypes.activity, 'pinned'],
    queryFn: getPinnedActivities,
  });
};

export default useHook;
